

import { EditableShapeNode, I18n, Property, ShapeType, command } from "luminicad-core";
import { IStep, SelectShapeStep } from "../../step";
import { CreateCommand } from "../createCommand";

@command({
    name: "create.thickSolid",
    display: "command.thickSolid",
    icon: `<svg viewBox="0 0 511.873 511.873" fill="none">
        <polygon points="159.937,166.72 159.937,454.72 143.937,448 31.937,400 31.937,256 31.937,112 47.937,118.72 
            143.937,160" fill="#1F77B4" opacity="0.7"></polygon>
        <polygon points="271.937,22.72 383.937,70.72 271.937,118.72 159.937,166.72 143.937,160 47.937,118.72 
            31.937,112 143.937,64 255.937,16" fill="#1F77B4" opacity="0.7"></polygon>
        <path d="M390.241,56.016l-112-48l-0.112-0.048l-16-6.72c-4-1.68-8.512-1.664-12.496,0.048l-112,48l-112,48
            c-0.336,0.144-0.592,0.4-0.912,0.56c-0.544,0.272-1.12,0.48-1.648,0.816c-0.288,0.192-0.512,0.464-0.784,0.688
            c-0.448,0.352-0.864,0.704-1.28,1.088c-0.656,0.624-1.232,1.296-1.776,2.016c-0.336,0.432-0.656,0.864-0.944,1.328
            c-0.496,0.832-0.88,1.712-1.216,2.624c-0.16,0.448-0.384,0.848-0.512,1.296c-0.384,1.392-0.624,2.816-0.624,4.288v144v144
            c0,6.416,3.792,12.176,9.696,14.704l112,48l0.112,0.048l16,6.72c4.928,2.064,10.592,1.536,15.056-1.424
            c4.448-2.96,7.136-7.984,7.136-13.328V177.264l102.304-43.84l112-48c5.904-2.528,9.696-8.288,9.696-14.704
            S396.145,58.544,390.241,56.016z M143.937,430.592l-96-41.136V256V136.128l89.68,38.56l0.128,0.048l6.192,2.624V430.592z
            M265.633,104.016l-105.76,45.328l-9.648-4.048l-77.536-33.344l77.552-33.232l105.76-45.328l9.744,4.096l-0.112-0.048l77.68,33.296
            L265.633,104.016z" fill="#808080"></path>
        <polygon points="479.937,256 479.937,400 367.937,448 255.937,496 255.937,352 255.937,208 367.937,160 
            479.937,112" fill="#FFFFFF" opacity="0.2"></polygon>
        <polygon points="271.937,118.72 383.937,70.72 479.937,112 367.937,160 255.937,208 159.937,166.72" fill="#FFFFFF" opacity="0.2"></polygon>
        <polygon points="255.937,208 255.937,352 255.937,496 159.937,454.72 159.937,166.72" fill="#FFFFFF" opacity="0.2"></polygon>
        <path d="M495.297,107.68c-0.128-0.464-0.336-0.864-0.512-1.296c-0.336-0.912-0.72-1.776-1.216-2.608
            c-0.288-0.48-0.624-0.896-0.96-1.344c-0.528-0.704-1.104-1.36-1.744-1.968c-0.432-0.4-0.864-0.784-1.328-1.136
            c-0.288-0.208-0.496-0.496-0.8-0.688c-0.496-0.336-1.056-0.512-1.568-0.784c-0.32-0.16-0.576-0.416-0.912-0.56l-96-41.28
            c-4.032-1.744-8.576-1.744-12.624,0l-112,48l-112,48c-0.336,0.144-0.592,0.4-0.912,0.56c-0.528,0.272-1.088,0.448-1.584,0.784
            c-0.304,0.192-0.512,0.464-0.8,0.688c-0.48,0.352-0.912,0.72-1.328,1.12c-0.64,0.608-1.216,1.264-1.744,1.952
            c-0.336,0.448-0.672,0.88-0.96,1.36c-0.496,0.816-0.864,1.68-1.2,2.576c-0.176,0.448-0.384,0.864-0.512,1.328
            c-0.4,1.376-0.64,2.8-0.656,4.272c0,0.016,0,0.032,0,0.048l0,0l0,0v288c0,6.368,3.824,12.176,9.68,14.704l96,41.28
            c0.176,0.08,0.368,0.08,0.544,0.16c0.656,0.256,1.328,0.416,2.016,0.576c0.608,0.144,1.184,0.304,1.792,0.384
            c0.656,0.08,1.312,0.064,1.984,0.064c0.656,0,1.28,0.016,1.936-0.064c0.624-0.08,1.216-0.24,1.824-0.4
            c0.672-0.16,1.344-0.32,1.984-0.576c0.176-0.064,0.368-0.08,0.544-0.16l112-48l112-48c5.904-2.496,9.696-8.256,9.696-14.672V256V112
            C495.937,110.512,495.697,109.072,495.297,107.68z M239.937,352v119.696l-64-27.52V191.008l64,27.52V352z M255.953,190.592
            l-55.456-23.84l77.744-33.312l105.68-45.296l55.456,23.84l-77.744,33.312L255.953,190.592z M463.937,389.456l-102.304,43.84
            l-89.696,38.432V352V218.544l102.304-43.84l89.696-38.432V256V389.456z" fill="#808080"></path>
    </svg>`,
})
export class ThickSolidCommand extends CreateCommand {
    @Property.define("command.thickSolid")
    get thickness() {
        return this.getPrivateValue("thickness", 10);
    }
    set thickness(value: number) {
        this.setProperty("thickness", value);
    }

    protected override geometryNode() {
        let shape = this.stepDatas[0].shapes[0].shape;
        let thickSolid = this.application.shapeFactory.makeThickSolidBySimple(shape, this.thickness);
        return new EditableShapeNode(this.document, I18n.translate("command.thickSolid"), thickSolid.value);
    }

    protected override getSteps(): IStep[] {
        return [new SelectShapeStep(ShapeType.Shape, "prompt.select.shape")];
    }
}
